import Classic from './classic'
import SecureInput from './SecureInput'

const Inputs = {
  Classic,
  Secure: SecureInput
}

export default Inputs
